import { render } from "./Login2Fa.vue?vue&type=template&id=e429e83a&scoped=true"
import script from "./Login2Fa.vue?vue&type=script&lang=js"
export * from "./Login2Fa.vue?vue&type=script&lang=js"

import "./Login2Fa.vue?vue&type=style&index=0&id=e429e83a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e429e83a"]])

export default __exports__